
import { defineComponent, PropType } from 'vue'
import Authors from './Authors.vue'
import numeral from 'numeral'
import Paginate from '@hennge/vue3-pagination'
import Loader from './Loader.vue'
import LitReviewButton from './LitReviewButton.vue'
import navigation from '../navigation'
import { Author, PaperID } from '@/types/incitefulTypes'
import {
  ChevronDownIcon,
  ChevronUpIcon,
  DocumentReportIcon
} from '@heroicons/vue/outline'
import SaveDropDown from './SaveDropDown.vue'
import PaperModalButton from './modals/PaperModalButton.vue'
import { QueryResults } from '../types/incitefulTypes'

export default defineComponent({
  name: 'TableView',
  components: {
    Authors,
    Paginate,
    Loader,
    LitReviewButton,
    ChevronDownIcon,
    ChevronUpIcon,
    DocumentReportIcon,
    SaveDropDown,
    PaperModalButton
  },
  props: {
    results: {} as PropType<QueryResults>,
    errorMsg: {} as PropType<string | undefined>,
    sql: {} as PropType<string | undefined>,
    loading: {} as PropType<boolean>,
    ids: {} as PropType<PaperID[]>,
    filters: {} as PropType<Record<string, string>>,
    emptyMessage: String,
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      currentPage: 1,
      sortedBy: undefined as string | undefined,
      sortDescending: undefined as boolean | undefined
    }
  },
  watch: {
    results: function () {
      this.currentPage = 1
    }
  },
  computed: {
    columns(): string[] | undefined {
      if (this.results) {
        return this.getColumnNames(this.results)
      }

      return undefined
    },
    numPages(): number {
      if (this.results) {
        return Math.ceil(this.results.length / this.pageSize)
      } else {
        return 0
      }
    },
    sortedResults(): QueryResults | undefined {
      if (
        this.sortedBy !== undefined &&
        this.results &&
        this.results.length > 0
      ) {
        const sorted = [...this.results].sort((a, b) => {
          var res = 0

          if (this.sortedBy !== undefined) {
            if (a[this.sortedBy] > b[this.sortedBy]) {
              res = 1
            }
            if (a[this.sortedBy] < b[this.sortedBy]) {
              res = -1
            }

            if (this.sortDescending) {
              res = res * -1
            }
          }

          return res
        })
        return sorted
      }
      return this.results
    },
    pagedResults(): QueryResults | undefined {
      if (this.sortedResults) {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        return this.sortedResults.slice(start, end)
      }

      return undefined
    },
    queryLink(): unknown {
      if (this.ids && this.ids.length === 1) {
        return {
          path: navigation.getPaperQueryUrl(this.ids[0]),
          query: { sql: this.sql }
        }
      } else {
        return {
          name: 'LitReviewQuery',
          query: {
            ids: this.ids,
            sql: this.sql
          }
        }
      }
    },
    resultIds(): PaperID[] {
      if (this.results && this.hasPaperID())
        return this.results.map(p => p.paper_id as PaperID)
      else return []
    }
  },
  methods: {
    format(val: unknown): string {
      if (typeof val === 'number') {
        return numeral(val).format('0.[000000]')
      } else if (typeof val === 'string') {
        return val
      } else {
        return ''
      }
    },
    rowClass(index: number): string {
      return index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
    },
    getColumnNames(val: QueryResults): string[] {
      if (
        typeof val !== 'object' ||
        val.length === 0 ||
        val[0] === undefined ||
        typeof val[0] !== 'object'
      ) {
        return []
      }

      const cols = Object.keys(val[0])
      const specialCols = [
        'authors',
        'doi',
        'title',
        'journal',
        'author_name',
        'paper_id',
        'affiliation'
      ]
      return cols.filter(v => !specialCols.includes(v))
    },

    hasPaperID(): boolean {
      return (
        this.results !== undefined &&
        this.results.length > 0 &&
        typeof this.results[0] === 'object' &&
        this.results[0].paper_id !== undefined
      )
    },
    canViewGraphs(): boolean {
      // return this.hasPaperID() && options.getGraphStatus();
      return false
    },
    viewGraph(): void {
      if (this.results) {
        const ids = [...(this.ids ?? [])]
        this.results.forEach(r => {
          if (ids.indexOf(r.paper_id as PaperID) === -1) {
            ids.push(r.paper_id as PaperID)
          }
        })
      }
    },
    turnPage(pageNum: number): void {
      this.currentPage = pageNum
    },
    sortBy(column: string): void {
      if ((this.sortedBy = column)) {
        this.sortDescending = !this.sortDescending
      } else {
        this.sortedBy = column
      }
      this.currentPage = 1
    }
  }
})
